module.exports = __webpack_public_path__ + "img/ic_topic_training-active.e9810fd3.svg";